import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LimitPipeModule } from '@shared/core/pipes/limit';
import { TileForPromotionItemModule } from '@shared/core/components/tiles/tilesTypes/forPromotionItem';

import { ListForPromotionItemsComponent } from './list-for-promotion-items.shared.component';

@NgModule({
    declarations: [
        ListForPromotionItemsComponent
    ],
    imports: [
        CommonModule,
        LimitPipeModule,
        TileForPromotionItemModule,
    ],
    exports: [
        ListForPromotionItemsComponent
    ],
})
export class ListForPromotionItemsModule { }
